import React from 'react';
import PropTypes from 'prop-types';
import RequestedShippingService from '../../../../../fulfillment-planner/requested-shipping-service';
import RequestedShippingServiceLabel from '../../../../../fulfillment-planner/requested-shipping-service/label';

import style from './style.module.less';

const RequestedService = ({ fulfillmentPlanId }) => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <RequestedShippingServiceLabel />
      </div>
      <div className={style['requested-service']}>
        <RequestedShippingService fulfillmentPlanId={fulfillmentPlanId} />
      </div>
      <div />
    </React.Fragment>
  );
};

RequestedService.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default RequestedService;
